import { oc } from "@orpc/contract";
import { z } from "zod";
import { ReportCanvasLayoutSchema } from "@erp/shared-types";

// The serialized layout shape and its size caps live in @erp/shared-types
// (`reportCanvas.ts`), shared with the query-builder saved-report format.
// Re-exported here so canvas code keeps a single import source for the wire
// contract.
export {
  ReportCanvasLayoutSchema,
  CanvasComponentConfigSchema,
  REPORT_CANVAS_MAX_ROWS,
  REPORT_CANVAS_MAX_CELLS_PER_ROW,
} from "@erp/shared-types";
export type {
  ReportCanvasLayout,
  CanvasComponentConfig,
} from "@erp/shared-types";

export const GetReportCanvasConfigInputSchema = z.object({
  surfaceId: z.string().min(1),
});

export const GetReportCanvasConfigResponseSchema = z
  .object({
    layout: ReportCanvasLayoutSchema,
  })
  .nullable();

export const UpsertReportCanvasConfigInputSchema = z.object({
  surfaceId: z.string().min(1),
  layout: ReportCanvasLayoutSchema,
});

export const UpsertReportCanvasConfigResponseSchema = z.object({
  layout: ReportCanvasLayoutSchema,
});

export const ResetReportCanvasConfigInputSchema = z.object({
  surfaceId: z.string().min(1),
});

export const ResetReportCanvasConfigResponseSchema = z.object({
  ok: z.boolean(),
});

export const userReportCanvasConfigsContracts = {
  get: oc
    .input(GetReportCanvasConfigInputSchema)
    .output(GetReportCanvasConfigResponseSchema)
    .route({ method: "GET" }),
  upsert: oc
    .input(UpsertReportCanvasConfigInputSchema)
    .output(UpsertReportCanvasConfigResponseSchema)
    .route({ method: "POST" }),
  reset: oc
    .input(ResetReportCanvasConfigInputSchema)
    .output(ResetReportCanvasConfigResponseSchema)
    .route({ method: "POST" }),
} as const;

export type GetReportCanvasConfigInput = z.infer<
  typeof GetReportCanvasConfigInputSchema
>;
export type GetReportCanvasConfigResponse = z.infer<
  typeof GetReportCanvasConfigResponseSchema
>;
export type UpsertReportCanvasConfigInput = z.infer<
  typeof UpsertReportCanvasConfigInputSchema
>;
export type UpsertReportCanvasConfigResponse = z.infer<
  typeof UpsertReportCanvasConfigResponseSchema
>;
export type ResetReportCanvasConfigInput = z.infer<
  typeof ResetReportCanvasConfigInputSchema
>;
export type ResetReportCanvasConfigResponse = z.infer<
  typeof ResetReportCanvasConfigResponseSchema
>;
